<template>
  <div class="cut-video-main">
    <div class="cut-begin-video">
      <video muted playsinline @ended="onVideoEnded">
        <source src="../../static/cut-video.mp4" type="video/mp4">
      </video>
    </div>
    <!-- 黑色背景遮罩 -->
    <div class="black-backgroud">
      <div class="black-background-move"></div>
      <div class="black-backgroud-image">
        <img src="../../static/series/cutbed/taishi_cut.png" alt="" ref="targetImage">
      </div>

      <div class="black-background-textcontent">
        <span class="cut-video-title">{{ $t('series.power') }}</span>
        <div class="cut-video-div">
          <span class="main-span">
              <span ref="cut-video-text1" class="cut-video-content1">{{ $t('series.power_text1') }}</span>
              <span ref="cut-video-text2" class="cut-video-content1">{{ $t('series.power_text2') }}</span>
              <span ref="cut-video-text3" class="cut-video-content1">{{ $t('series.power_text3') }}</span>
              <span ref="cut-video-text4" class="cut-video-content1">{{ $t('series.power_text4') }}</span>
              <span ref="cut-video-text5" class="cut-video-content1">{{ $t('series.power_text5') }}</span>
              <span ref="cut-video-text6" class="cut-video-content1">{{ $t('series.power_text6') }}</span><br>
          </span>
          <span ref="cut-video-text7" class="cut-video-content1">{{ $t('series.power_text7') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CutVideo',
  data() {
    return {
      isMobile: false,
      isAbsolute: false,
      hasRestoredFixed: false,
      lastAnimTime: 0,
      lastScrollY: 0,
      masterLine: null,
      stateChangeTimer: null
    }
  },
  methods: {
    checkDevice() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleResize() {
      this.checkDevice();
    },
    onVideoEnded() {
    },
  },
  mounted() {
    // 初始化滚动位置
    this.lastScrollY = window.scrollY;

    // 初始化设备检测
    this.checkDevice();
    // window.addEventListener('resize', this.handleResize);

    this.$gsap.set('.black-backgroud', {
      opacity: 0
    });
    this.$gsap.set('.black-background-textcontent', {
      y: 460,
    });
    this.$gsap.set(['.cut-video-title', '.cut-video-div'], {
      opacity: 0,
    });
    const videoDiv = document.querySelector('.cut-begin-video');
    const video = videoDiv.querySelector('video');
    const backgroundBlack = document.querySelector('.black-backgroud');
    const bgParent = backgroundBlack.parentElement; // 父元素（静止不动）

    videoDiv.style.position = 'absolute';
    const masterLine = this.$gsap.timeline({
      scrollTrigger: {
        trigger: '.cut-begin-video',
        start: 'top 10%',
        end: 'bottom -150%',
        markers: false,
        scrub: 1,
        toggleActions: 'play none none reverse',
        once: false,
        onEnter: () => {
          const rect = videoDiv.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          // 判断元素是否真正在视口内
          const isVisible = rect.bottom > 0 && rect.top < viewportHeight;
          if (isVisible) {
            videoDiv.style.position = 'fixed';
            video.play();
            backgroundBlack.style.position = 'fixed';
            backgroundBlack.style.top = '0';
            backgroundBlack.style.left = '0';
            backgroundBlack.style.width = '100%';
            backgroundBlack.style.height = '100%';
          } else {
            // console.log(rect.bottom + ' > 0 &&' + rect.top + '< ' + viewportHeight)
          }
        },
        // 向下滚动超出范围：切换absolute，固定当前位置（父元素静止，简化计算）
        onLeave: () => {
          this.isAbsolute = true;
          this.hasRestoredFixed = false;
          videoDiv.style.position = 'absolute';
          const viewportRect = backgroundBlack.getBoundingClientRect();
          const parentRect = bgParent.getBoundingClientRect();
          backgroundBlack.style.position = 'absolute';
          backgroundBlack.style.top = `${viewportRect.top - parentRect.top}px`;
          backgroundBlack.style.left = `${viewportRect.left - parentRect.left}px`;
          backgroundBlack.style.width = `${viewportRect.width}px`;
          backgroundBlack.style.height = `${viewportRect.height}px`;
        },
        // 向上滚动超出范围：恢复fixed，不随滚动移动
        onLeaveBack: () => {
          videoDiv.style.position = 'absolute';
        },
      }
    });

    // 1. backgroundBlack 淡入（始终固定，仅控制透明度）
    masterLine.to(backgroundBlack, {
      opacity: 1,
      duration: 2
    }, 0);

    // 1. 第一段动画（延迟1秒开始，时长2秒）
    masterLine.to(videoDiv, {
      opacity: 0,
      delay: 1,
      duration: 2
    }, 1);

    // 移除黑色背景等动画（延后开始，时长延长）
    masterLine.to('.black-background-move', {
      y: -500,
      duration: 2,
      opacity: 0,
      ease: "power2.out"
    }, 3);

    masterLine.to('.black-backgroud-image', {
      y: 100,
      scale: 1.1,
      duration: 2,
      ease: "power2.out"
    }, 3);

    masterLine.to('.cut-video-title', {
      opacity: 1,
      y: -50,
      ease: "power2.in",
      duration: 2,
    }, 3);

    // 2. 第二段（延后到5秒，时长2秒）
    masterLine.to('.black-backgroud-image', {
      scale: 1.2,
      duration: 2,
      ease: "power2.out"
    }, 5);

    masterLine.to('.cut-video-title', {
      opacity: 1,
      y: -80,
      ease: "power2.in",
      duration: 2,
    }, 5);

    masterLine.to('.cut-video-div', {
      opacity: 1,
      y: -350,
      duration: 2,
      ease: "power2.in",
    }, 5);

    masterLine.to(this.$refs['cut-video-text1'], {
      color: '#000',
      duration: 2,
      ease: "power2.in",
    }, 5);

    masterLine.to('.cut-video-title', {
      color: '#808080',
      duration: 2,
      ease: "power2.in",
    }, 5);

    // 3. 第三段（延后到7秒）
    masterLine.to('.black-background-textcontent', {
      y: 380,
      duration: 1.5,
      ease: "power2.in",
    }, 7);

    masterLine.to(this.$refs['cut-video-text1'], {
      color: '#808080',
      duration: 1.5,
      ease: "power2.in",
    }, 7);

    masterLine.to(this.$refs['cut-video-text2'], {
      color: '#000',
      duration: 1.5,
      ease: "power2.in",
    }, 7);

    // 4. 第四段（延后到9秒）
    masterLine.to('.black-background-textcontent', {
      y: 250,
      duration: 1.5,
      ease: "power2.in",
    }, 9);

    masterLine.to(this.$refs['cut-video-text2'], {
      color: '#808080',
      duration: 1.5,
      ease: "power2.in",
    }, 9);

    masterLine.to(this.$refs['cut-video-text3'], {
      color: '#000',
      duration: 1.5,
      ease: "power2.in",
    }, 9);

    // 5. 第五段（延后到11秒）
    masterLine.to('.black-background-textcontent', {
      y: 70,
      duration: 1.5,
      ease: "power2.in",
    }, 11);

    masterLine.to(this.$refs['cut-video-text3'], {
      color: '#808080',
      duration: 1.5,
      ease: "power2.in",
    }, 11);

    masterLine.to(this.$refs['cut-video-text4'], {
      color: '#000',
      duration: 1.5,
      ease: "power2.in",
    }, 11);

    // 6. 第六段（延后到13秒）
    masterLine.to('.black-background-textcontent', {
      y: -80,
      duration: 1.5,
      ease: "power2.in",
    }, 13);

    masterLine.to(this.$refs['cut-video-text4'], {
      color: '#808080',
      duration: 1.5,
      ease: "power2.in",
    }, 13);

    masterLine.to(this.$refs['cut-video-text5'], {
      color: '#000',
      duration: 1.5,
      ease: "power2.in",
    }, 13);

    // 7. 第七段（延后到15秒）
    masterLine.to('.black-background-textcontent', {
      y: -180,
      duration: 1.5,
      ease: "power2.in",
    }, 15);

    masterLine.to(this.$refs['cut-video-text5'], {
      color: '#808080',
      duration: 1.5,
      ease: "power2.in",
    }, 15);

    masterLine.to(this.$refs['cut-video-text6'], {
      color: '#000',
      duration: 1.5,
      ease: "power2.in",
    }, 15);

    // 8. 第八段（延后到17秒，时长延长）
    masterLine.to('.main-span', {
      opacity: 0,
      y: -100,
      duration: 2,
      ease: "power2.in",
    }, 17);

    masterLine.to('.cut-video-title', {
      opacity: 0,
      y: -100,
      duration: 2,
      ease: "power2.in",
      onComplete: () => {

      },
    }, 17);

    masterLine.to(this.$refs['cut-video-text7'], {
      color: '#46b1e1',
      y: -130,
      duration: 2,
      ease: "power2.in",
    }, 18);
  },
}
</script>

<style>
.cut-video-main {
  height: 300vh;
  position: relative;
}

.cut-begin-video {
  height: 120vh;
  z-index: 3;
  position: absolute;
  overflow: hidden;
  width: 100%;
  left: 0;
  top: 0;
  object-fit: cover;
  box-sizing: border-box;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}


.black-backgroud {
  height: 100vh;
  width: 100%;
  position: absolute;
  display: flex;
  align-items: center;
}

.black-background-move {
  height: 1000px;
  width: 100%;
  position: absolute;
  background-color: black;
}

.black-backgroud-image {
  width: 100%;
  position: absolute;
  top: 40%;
  z-index: 2;
  display: flex;
  justify-content: center; /* 居中图片 */

  img {
    width: 70%;
  }
}

.black-background-textcontent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 40%;
}

.cut-video-title {
  margin-bottom: 320px;
  font-size: var(--font-size-xl2);
}

.cut-video-div {
  display: flex;
  flex-direction: column;
  width: 75%;
  text-align: left;
}


.cut-video-content1 {
  font-size: var(--font-size-xl);
  color: #808080;
}

/* 手机端适配 - 屏幕宽度小于768px时 */
@media (max-width: 768px) {
  .cut-video-main,
  .cut-begin-video,
  .black-backgroud,
  .black-background-move {
    height: 700px; /* 移动端高度减小 */
  }

  .cut-begin-video {
    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .black-backgroud-image {

    top: 30%; /* 图片位置上移 */

    img {
      width: 90%; /* 图片占比增大 */
    }
  }

  .black-background-textcontent {
    margin-left: 15%; /* 文字左移，避免超出屏幕 */
    width: 80%; /* 限制文字区域宽度 */
  }

  .cut-video-title {
    margin-bottom: 150px; /* 标题与内容间距减小 */
    font-size: clamp(1.5rem, 5vw, var(--font-size-xl2)); /* 响应式字体 */
  }

  .cut-video-div {
    width: 100%; /* 文字区域占满 */
  }

  .cut-video-content1 {
    font-size: clamp(1rem, 4vw, var(--font-size-xl)); /* 响应式字体 */
    line-height: 1.6; /* 增加行高，提升可读性 */
  }

  .main-span {
    display: block; /* 确保换行正常 */
    margin-bottom: 10px;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .cut-video-main,
  .cut-begin-video,
  .black-backgroud,
  .black-background-move {
    height: 600px;
  }

  .black-backgroud-image {
    top: 25%;
  }

  .cut-video-title {
    margin-bottom: 120px;
  }
}
</style>
